import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/feature-toggles": {
        title: "Feature Toggles",
        authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name]
    }
};
